export function moveArrayItem(list, index, direction) {
  const nextIndex = direction === "up" ? index - 1 : index + 1;
  if (index < 0 || index >= list.length) return list;
  if (nextIndex < 0 || nextIndex >= list.length) return list;

  const copy = [...list];
  const [item] = copy.splice(index, 1);
  copy.splice(nextIndex, 0, item);
  return copy;
}

export function updateArrayItem(list, index, patch) {
  if (index < 0 || index >= list.length) return list;
  const copy = [...list];
  copy[index] = {
    ...(copy[index] || {}),
    ...patch
  };
  return copy;
}

export function removeArrayItem(list, index) {
  if (index < 0 || index >= list.length) return list;
  const copy = [...list];
  copy.splice(index, 1);
  return copy;
}

export function prependArrayItem(list, item) {
  return [item, ...list];
}

export function updateArrayItemById(list, id, patch) {
  return list.map((item) => (item.id === id ? { ...item, ...patch } : item));
}

export function removeArrayItemById(list, id) {
  return list.filter((item) => item.id !== id);
}

export function moveArrayItemById(list, id, direction) {
  const index = list.findIndex((item) => item.id === id);
  if (index === -1) return list;
  return moveArrayItem(list, index, direction);
}
